import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const RECLAMATION_INNER_REASON_URL = 'reclamation/inner-reasons'

const errors = createHandbookResponseErrors('причину внутренней рекламации', 'причин внутренней рекламации')

export const ReclamationInnerReasonApi = createNewHandbookApi(RECLAMATION_INNER_REASON_URL, errors)
